import ImagesMainBannerJanuary2025BottlesOfTheMonthPng from '@/public/images/main-banner/january-2025/bottles-of-the-month.png';
import ImagesMainBannerJanuary2025GlenfiddichPng from '@/public/images/main-banner/january-2025/glenfiddich.png';
import ImagesMainBannerJanuary2025LoveLetterInABottlePng from '@/public/images/main-banner/january-2025/love-letter-in-a-bottle.png';

export {
  ImagesMainBannerJanuary2025BottlesOfTheMonthPng,
  ImagesMainBannerJanuary2025GlenfiddichPng,
  ImagesMainBannerJanuary2025LoveLetterInABottlePng,
};
